import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output
} from '@angular/core';
import { Router } from '@angular/router';
import { NavMenuItem } from 'src/app/interfaces/nav-menu-item';
import { ToastService } from 'src/app/services/toast.service';

@Component({
  selector: 'app-nav-sub-menu',
  templateUrl: './nav-sub-menu.component.html',
  styleUrls: ['./nav-sub-menu.component.less'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class NavSubMenuComponent implements OnInit {
  constructor(
    private ToasterService: ToastService,
    private router: Router
  ) {}

  // selectedItems: Set<NavMenuItem> = new Set();
  @Input() subNavMenu: NavMenuItem[] = [];
  @Output() menuSelectionEvent = new EventEmitter<NavMenuItem>();

  menuSelection(NavMenuItem: NavMenuItem) {
    this.menuSelectionEvent.emit(NavMenuItem);
  }

  subMenuClick(NavMenuItem: NavMenuItem) {
    this.menuSelection(NavMenuItem);

    const {
      link,
      linkFn,
      subMenu,
      isCollapsed,
      isExternalLink,
      isUnSelectable
    } = NavMenuItem;

    if (!isUnSelectable) {
      if (link) {
        if (isExternalLink) {
          if (typeof link !== 'string') {
            throw new Error('Link is not a string.');
          }
          window.open(link, '_blank');
        } else if (typeof link === 'string') {
          this.router.navigateByUrl(link);
        } else if (Array.isArray(link)) {
          this.router.navigate(link);
        }
      }

      if (linkFn) {
        linkFn();
      }

      if (subMenu) {
        Object.assign(NavMenuItem, { isCollapsed: !isCollapsed });
      }
    }
  }

  replaceSpaces(itemName: string) {
    return itemName.replace(' ', '-');
  }

  ngOnInit(): void {}
}
